// extracted by mini-css-extract-plugin
module.exports = {"text":"b7635b5199--text--xuoco"};